import axios from 'axios';
import axiosErrorResponse from '../../../../../helpers/axiosErrorResponse';
import logger from '../../../../../logger/emitter';
import { FETCH_ERROR } from '../../../../../helpers/constants';

/**
 * Post bigQuery events to a dedicated service.
 * Each event should respect our raw events bigQuery schema:
 * https://bigquery.cloud.google.com/table/fiverr-bigquery:raw.events
 * @param {String} url the service's url
 * @param {Object[]} events
 * @param {string} rootKey - root key for wrapping events array (Optional)
 */
export const post = (url, events, rootKey) => {
    if (!url) {
        const error = new Error(`expected a string URL, instead got ${typeof url} (${url}).`);

        return Promise.reject(error);
    }

    if (!Array.isArray(events)) {
        const error = new Error(`expected an array of events, instead got ${typeof events} (${events}).`);

        return Promise.reject(error);
    }

    if (events.length === 0) {
        const error = new Error('expected non-empty array of events, instead got an empty array.');

        return Promise.reject(error);
    }

    const eventsPayload = rootKey ? { [rootKey]: events } : events;

    return axios.post(
        url,
        eventsPayload
    ).catch((error) => {
        /**
         * If the browser
         * or an extension of the browser
         * or another client actor abort the request
         * we don't care about the request
         * and no need to log them.
         */
        if (
            error.request &&
            error.request.readyState !== XMLHttpRequest.DONE
        ) {
            return;
        }

        /**
         * We don't want to handle the forbidden requests.
         * PerimeterX is doing its job
         * and if he say that a request should be forbidden
         * we don't care about those dirty bigQuery events
         * and no need to log them.
         */
        if (
            error.response &&
            [ 403, 429 ].includes(error.response.status)
        ) {
            return;
        }

        logger.warn(error, {
            message: `${events.length} events failed: ${error.message}.`,
            code: FETCH_ERROR,
            description: [
                'Events:',
                ...events.map(
                    ({ group, type }) => `Group: ${group}, Type: ${type}`
                )
            ].join('\n'),
            details: {
                url: window.location.href,
                originalUrl: url,
                response: axiosErrorResponse(error)
            }
        });
    });
};
